import { Splide, SplideSlide } from '@splidejs/react-splide';
import slideNumber from './carousel_slide_number';

const QuoteCarousel = ({ quotes }) => (
  <div className="contentful__carousel contentful__container__quote_carousel">
    <Splide
      options={{ pagination: false, type: 'fade' }}
      hasTrack={false}
      className="splide fl fl-col-reverse ai-fe"
      role="group"
      aria-label="product image carousel"
      extensions={{ slideNumber }}>
      <div className="splide__track mb-16">
        <ul className="splide__list">
          {quotes.map(
            ({ sys: { id }, fields: { content, name, title } }, i) => (
              <SplideSlide
                className={`similar-stock-carousel__item splide__slide
                    splide__slide--${i}`}
                key={id}
                data-testid="splide__slide--similarstock-item">
                {content && (
                  <div className="bg-cef-red p-32 tc-white">
                    <p className="fs-24 lh-1-2 fw-600 mb-24">{content}</p>
                    <p>
                      <strong>{name}</strong> &#x2022; {title}
                    </p>
                  </div>
                )}
              </SplideSlide>
            ),
          )}
        </ul>
      </div>
    </Splide>
  </div>
);

export default QuoteCarousel;
